export enum FormState {
  UPDATE = 'update',
  CREATE = 'create',
}
